









































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import CompanyLogo from "@/components/Atoms/CompanyLogo/index.vue";
import { formatDate } from "@/helpers/date-helper";
import { ApiResponse } from "@/api/types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Notification",
  components: {
    Heading,
    Suffix,
    CompanyLogo
  },
  props: {
    notification: {
      type: Object as PropType<Props["notification"]>,
      required: true
    }
  },
  computed: {
    notificationClasses() {
      return [
        "notification",
        {
          "notification--unread": !this.notification.read_at,
          "notification--link": !!this.notification.url
        }
      ];
    },
    formattedDate() {
      return formatDate(this.notification.datetime);
    },
    iconName() {
      if (
        this.notification.large_category ===
          ApiResponse.NOTIFICATION_LARGE_CATEGORIES.COMPETITOR &&
        this.notification.category ===
          ApiResponse.NOTIFICATION_CATEGORIES.BULK_INSERT
      ) {
        return "Companies";
      } else if (
        this.notification.large_category ===
        ApiResponse.NOTIFICATION_LARGE_CATEGORIES.UNIVERSITY
      ) {
        return "University";
      }
      return "";
    }
  },
  methods: {
    handleClick() {
      this.$emit("readNotification", this.notification.id);
      if (!this.notification.url) return;
      let href: string;
      if (this.notification.url.startsWith("/")) {
        href = this.$router.resolve({
          path: this.notification.url
        }).href;
      } else {
        href = this.notification.url;
      }
      window.open(href, "_blank", "noopener");
    }
  }
});
